import Root from 'Root'
import { GroupsPlaceholderHome } from '@features/groups/screens/GroupsPlaceholderHome'
import { HelpCentreScreen } from '@features/helpCentre'
import Home from '@features/home/screens/HomeScreen'
import IncidentCaseRoute from '@features/logs/screens/IncidentCaseRoute'
import IncidentLogEditScreen from '@features/logs/screens/IncidentLogEditScreen'
import IncidentReportCreateCaseScreen from '@features/logs/screens/IncidentReportCreateCaseScreen'
import IncidentReportEditCaseScreen from '@features/logs/screens/IncidentReportEditCaseScreen'
import LogsDashboard from '@features/logs/screens/LogsDashboard'
import { ForceMFAScreen } from '@features/mfa/ForceMFAScreen'
import { UserRole } from '@lmc/ts-common'
import { ProAdvert } from 'components/generic'
import { Navigate, Route } from 'react-router-dom'
import LogScreen from 'screens/Logs/LogScreen'
import { EMARPaywall } from 'screens/Residents/screens/ResidentEmarScreens/components'
import { groupReportsRoutes } from './groupReports'
import { homesRoutes } from './homes'
import noticeboardRoutes from './noticeboard'
import { onBoardingRoutes } from './onboarding'
import { organizationRoutes } from './organisation'
import { reportsRoutes } from './reports'
import { residentsRoutes } from './residents'
import rotaRoutes from './rota'
import { settingsRoutes } from './settings'
import todosRoutes from './todos'

// import { Suspense } from 'react'

type Role =
  | UserRole.auditView
  | UserRole.careHomeAdmin
  | UserRole.groupAdmin
  | UserRole.groupManager
  | UserRole.it
  | UserRole.management
  | UserRole.seniorCarer

const HomeRoute = (role: Role | null = UserRole.careHomeAdmin) => {
  switch (role) {
    case UserRole.groupManager:
      return <Route index element={<GroupsPlaceholderHome />} />
    case UserRole.groupAdmin:
      return <Route index element={<GroupsPlaceholderHome />} />
    case UserRole.it:
      return (
        <Route index element={<Navigate to="/organisation/list" replace />} />
      )
    case UserRole.seniorCarer:
    case UserRole.careHomeAdmin:
    case UserRole.management:
    case UserRole.auditView:
      return <Route index element={<Home />} />
    default:
      return null
  }
}

export const getRoutes = (
  role: Role | null = UserRole.careHomeAdmin,
  initResponse: any,
  carePlansListScreenV2Enabled: boolean
) => (
  <Route path="/" element={<Root initResponse={initResponse} />}>
    {HomeRoute(role)}
    {onBoardingRoutes}
    {residentsRoutes(carePlansListScreenV2Enabled)}
    {organizationRoutes(role)}
    <Route path="logs" element={<LogsDashboard />} />
    <Route path="mfa" element={<ForceMFAScreen />} />
    <Route path="logs/:id" element={<LogScreen />} />
    <Route path="logs/:id/edit" element={<IncidentLogEditScreen />} />
    <Route
      path="logs/:id/create-case"
      element={
        <IncidentCaseRoute v1Form={<IncidentReportCreateCaseScreen />} />
      }
    />
    <Route
      path="logs/:id/edit-case"
      element={<IncidentCaseRoute v1Form={<IncidentReportEditCaseScreen />} />}
    />
    {noticeboardRoutes(role)}
    {todosRoutes}
    {rotaRoutes}
    {homesRoutes}
    {groupReportsRoutes}
    {reportsRoutes}
    <Route path="pro-advert" element={<ProAdvert />} />
    <Route path="emar-activation" element={<EMARPaywall />} />
    <Route path="help" element={<HelpCentreScreen />} />
    {settingsRoutes}
    <Route path="*" element={<Navigate to="/" />} />
  </Route>
)
